import PeopleWidgetWithOutHolo from 'Components/common/components/PeopleWidgetWithOutHolo';
import styled from 'styled-components';
import { CompliancePerson } from 'Types/SRITypes';
import { ColumnDescriptor, ColumnType, TableColValue } from 'Types/TableTypes';
import { backgroundColorParsing } from 'Utils/UtilityFunctions';
import {
  primaryColor, primaryFont, primaryHeadingColor, SecondaryColorTwo,
} from 'Utils/utilsStyle';

const Typography = styled.span`
  font-family: ${primaryFont};
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  color: ${primaryHeadingColor};
  &.green {
    color: ${primaryColor}
  }
  &.person-name {
    margin-left: 10px;
  }
`;

const HeaderCell = styled.div`
  font-family: ${primaryFont};
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  color: ${SecondaryColorTwo};
`;

const PersonCell = styled.div`
  display: flex;
  align-items: center;
`;

export const useTable = <T extends Record<string, any>>(
  columnValues: TableColValue[],
): ColumnDescriptor<T>[] => {
  const getTableHeader = (value: string) => <HeaderCell className="cell-name">{value}</HeaderCell>;

  const getTableCell = (type: string, value: any) => {
    switch (type) {
      case ColumnType.PERSON: {
        const person = value as CompliancePerson;
        return (
          <PersonCell>
            <PeopleWidgetWithOutHolo
              diameter="30px"
              diameterSm="30px"
              diameterXsm="30px"
              ringPadding="2px"
              ringPaddingSm="2px"
              wrapperColor={backgroundColorParsing(person?.personalityTypes || [])}
              logo={person?.personImage}
              persona="#F0B520"
              disableNavigation
              margin="4px 0px"
            />
            <Typography className="person-name">{person?.personName}</Typography>
          </PersonCell>
        );
      }
      case ColumnType.DEFAULT:
        return <Typography>{value}</Typography>;
      case ColumnType.GREEN_TEXT:
        return <Typography className="green">{value}</Typography>;
      case ColumnType.DATE:
        return <Typography className="left-align">{value}</Typography>;
      default:
        return <Typography>{value}</Typography>;
    }
  };

  const getColumns = (columns: TableColValue[]): ColumnDescriptor<T>[] => columns.map((column) => {
    const {
      id, label, type, width,
    } = column;
    return {
      id,
      headerRenderer: () => getTableHeader(label),
      cellRenderer: (record: any) => getTableCell(type, record),
      width,
    };
  });

  return getColumns(columnValues);
};
